<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                flat
                dark
              >
                <v-toolbar-title>Name Change Form</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="firstName"
                    label="First Name"
                    name="firstName"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>

                  <v-text-field
                    v-model="lastName"
                    label="Last Name"
                    name="lastName"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="change()" color="secondary">Change Name</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import { CHANGE_USER_MUTATION } from '../../graphql/authenticationQueries.js';

  export default {
    props: {
      source: String,
    },
    data () {
      return {
        firstName: null,
        lastName: null
      }
    },
    apollo: {
      $client: 'authenticationClient'
    },
    methods: {
      async change(){
        const { firstName, lastName } = this.$data;
        try {
          const result = await this.$apollo.mutate({
            mutation: CHANGE_USER_MUTATION,
            variables: {
              firstName: firstName,
              lastName: lastName
            }
          });

          if(result.data.changeUser) {
            alert(`Successfully changed user info to '${firstName}' and '${lastName}'`);
          }
        } catch (error) {
          alert('Error when attempting to change user info');
        }
      }
    }
  }
</script>